import { shippingClient } from 'domain/HttpClients';

export const fetch = (ownerId) => shippingClient
  .Get('/api/credit-management')
  .withParams({ ownerId })
  .send();
